import { isEquipmentPlaceholderProduct } from 'utils/equipment-placeholder';
import type { ExistingEquipmentPositionSlot } from 'utils/existing-equipment';

export type EquipmentPlaceholderKind =
  | 'outdoorUnit'
  | 'evaporatorCoil'
  | 'airHandler'
  | 'furnace'
  | 'modularBlower';

export const EQUIPMENT_PLACEHOLDER_KIND_LABELS: Record<
  EquipmentPlaceholderKind,
  string
> = {
  outdoorUnit: 'Outdoor unit',
  evaporatorCoil: 'Evaporator coil',
  airHandler: 'Air handler',
  furnace: 'Furnace',
  modularBlower: 'Modular blower'
};

type LabelMatcher = { pattern: RegExp; kind: EquipmentPlaceholderKind };

const LABEL_MATCHERS: LabelMatcher[] = [
  { pattern: /furnace/i, kind: 'furnace' },
  { pattern: /blower/i, kind: 'modularBlower' },
  { pattern: /coil/i, kind: 'evaporatorCoil' },
  { pattern: /air handler/i, kind: 'airHandler' },
  { pattern: /condenser|air conditioner|heat pump/i, kind: 'outdoorUnit' }
];

const SLOT_FALLBACK_KINDS: Record<
  ExistingEquipmentPositionSlot,
  EquipmentPlaceholderKind
> = {
  outdoor: 'outdoorUnit',
  indoor: 'airHandler',
  blower: 'furnace'
};

export function equipmentPlaceholderKind(
  product: { name: string },
  slot: ExistingEquipmentPositionSlot
): EquipmentPlaceholderKind {
  const matched = LABEL_MATCHERS.find(({ pattern }) =>
    pattern.test(product.name)
  );
  return matched?.kind ?? SLOT_FALLBACK_KINDS[slot];
}

export function equipmentPlaceholderKindOf(
  product: { productId: number; name: string } | null | undefined,
  slot: ExistingEquipmentPositionSlot
): EquipmentPlaceholderKind | null {
  return product && isEquipmentPlaceholderProduct(product)
    ? equipmentPlaceholderKind(product, slot)
    : null;
}
